import { apiSlice } from "../api/apiSlice";
import {RenterTypeListAction} from "./ownershipSlice";

export const ownershipApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
    changeOwnerShip: builder.query({
        query: (body) => ({
          url: "ChangeOwnerShip/ChangeOwner",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

      UpdateCurrentOwnerShip: builder.query({
        query: (body) => ({
          url: "ChangeOwnerShip/UpdateCurrentOwnerShip",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

      AddRenters: builder.query({
        query: (body) => ({
          url: "ChangeOwnerShip/AddRenters",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

      UpdateRenters: builder.query({
        query: (body) => ({
          url: "ChangeOwnerShip/UpdateRenters",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

      getRenterTypes: builder.query({
        query: () =>
          `ChangeOwnerShip/GetRenterTypes`,
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
            const result = await queryFulfilled;
            if(result.isSuccess){
              dispatch(
                RenterTypeListAction({
                  RenterTypeList: result.data.data,
                })
              );
            }
            
          } catch (err) {}
        },
      }),

      UpdateContactPersons: builder.query({
        query: (body) => ({
          url: "Keyfree/UpdateContactPersons",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

      deleteRenters: builder.query({
        query: (body) => ({
          url: "Keyfree/DeleteRenters",
          method: "DELETE",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),

    }),
  });
  
  export const {
    useLazyChangeOwnerShipQuery,
    useLazyUpdateCurrentOwnerShipQuery,
    useLazyAddRentersQuery,
    useLazyUpdateRentersQuery,
    useLazyGetRenterTypesQuery,
    useLazyUpdateContactPersonsQuery,
    useLazyDeleteRentersQuery
  } = ownershipApi;
  